import React from 'react';
import PropTypes from 'prop-types';
import {Autocomplete, createFilterOptions} from "@material-ui/lab";
import {TextField, Chip} from "@material-ui/core";
import {getOptionsType} from './optionTypes';
import {formatName, sortArray} from '../../utils';
import removeCircle from '../../svgs/removeCircle.svg';
import arrow from '../../svgs/Arrow.svg';
import close from '../../svgs/X.svg';
import Input from "../Input-new/Input";

require('./Dropdown.scss');

const defaultFilterOptions = createFilterOptions();

const Dropdown = ({dropdownType = 'single', options, optionsType, optionKey, optionLabelKey, value, valueKey, firmName, label, data, hasAgentPercent, handleParentChange, handleInputParentChange, disabled = false, viewMode = false, groupBy = false, addNewItem, withAddNew, isFilter = false, theme = 'default', placeholder, hasDrawer, isFromProperty = false, deleted = false, typeKey, typeValue, getSelectedOption, className = '', viewClassName = '', index}) => {
    let optionList = options ? options : getOptionsType(optionsType,isFilter);

    const getOptionLabel = (option) => {
        if (option && option.type === 'div')
            return option;

        switch (optionsType) {
            case 'agent':
            case 'agent-all':
            case 'borrower':
            case 'buyer':
            case 'seller':
            case 'team':
                return option ? formatName(option) : '';
            case 'firm':
            case 'tenant':
            case 'lender':
                return option ? option.NAME : '';
            default:
                return option ? (optionLabelKey ? option[optionLabelKey] : optionKey ? option[optionKey] : option) : '';
        }
    };

    const getValuesForDropdown = (data, options, optionKey, type = 'multiple') => {
        if (!data || !options || !options.length) return [];

        let formattedQueryValues = data.ARCIMEDES_ROW_ID ? data.ARCIMEDES_ROW_ID : data.split(',');
        let response = [];

        options.forEach((el) => {
            if (!typeKey && (formattedQueryValues.includes(el) || formattedQueryValues.includes(el[optionKey]))
                || typeKey && formattedQueryValues.includes(el[optionKey]) && el.groupedBy === typeValue)
                response.push(el);
        });

        if (!response)
            response = [];
        if (type === "single")
            response = response[0] ? response[0] : null;
        if (getSelectedOption)
            getSelectedOption(response);
        return response;
    };

    const handleChangeDropdown = ({reason, valueKey, dropdownType = 'single', optionKey = null, alphabetic = false, parentData, isFilter = false}) => {
        const data = {...parentData};

        if (isFromProperty) {
            if (reason && ['LISTING_AGENT_4', 'BUYER_AGENT_4'].includes(valueKey) && reason.FIRM && reason.FIRM !== "0")
                data[valueKey + '_FIRM'] = reason.FIRM;

            if (['LISTING_AGENT_4', 'BUYER_AGENT_4'].includes(valueKey) && !reason)
                data[valueKey + '_FIRM'] = null;
        }

        if (!reason) {
            if (isFilter) delete data[valueKey];
            else {
                data[valueKey] = null;
                if (['agent-all', 'borrower'].includes(optionsType))
                    data[typeKey] = null;
            }
        } else {
            if (dropdownType === 'single') {
                data[valueKey] = optionKey ? reason[optionKey] : reason;
                if (['agent-all', 'borrower'].includes(optionsType))
                    data[typeKey] = reason.groupedBy;
            } else {
                let result = '';

                if (alphabetic) reason = sortArray(reason, (optionKey ? 'name' : null));

                reason.forEach(el => {
                    result += (optionKey ? el[optionKey] : el) + ',';
                });

                if (alphabetic) data[valueKey] = result.slice(0, -1);
                else data[valueKey] = result;
            }
        }
        handleParentChange(data, optionsType, (reason ? reason[optionKey] : ''), valueKey, typeKey, reason);
    };

    const handleChange = (key, value) => {
        handleInputParentChange(key, value);
    };

    const filterOptions = (options, state) => {
        const results = defaultFilterOptions(options, state);
        if (optionsType === 'firm')
            options.forEach((option, index) => {
                if (!Object.keys(option).length)
                    options.splice(index, 1);
            });

        if (['agent', 'buyer', 'seller', 'firm', 'lender', 'agent-all', 'borrower'].includes(optionsType) && !results.length && withAddNew)
            return [
                <div className='no-options-container' onClick={(e) => e.stopPropagation()}>
                    No results found
                    <div className='add-new'
                         onClick={(e) => {
                             if (optionsType === 'firm' && hasDrawer) addNewItem();
                             else if (optionsType === 'borrower') addNewItem(valueKey);
                             else addNewItem(valueKey, 'buyer', index);

                             const popper = document.getElementsByClassName('MuiAutocomplete-popper');
                             if (popper && popper[0]) popper[0].style.display = 'none';

                             e.stopPropagation();
                         }}>Add new {optionsType === 'agent-all' ? 'agent' :
                                        optionsType === 'borrower' ? 'buyer' : optionsType}
                    </div>
                    {
                        optionsType === 'borrower' &&
                        <div className='add-new'
                             onClick={(e) => {
                                 addNewItem(valueKey, 'seller', index);

                                 const popper = document.getElementsByClassName('MuiAutocomplete-popper');
                                 if (popper && popper[0]) popper[0].style.display = 'none';

                                 e.stopPropagation();
                             }}>
                            Add new seller
                        </div>
                    }
                </div>
            ];

        if (!results.length)
            return [
                <div className='no-options-container'
                     onClick={(e) => e.stopPropagation()}>
                    No results found
                </div>
            ];
        return results;
    };

    const values = getValuesForDropdown(value, optionList, optionKey, dropdownType);

    const getFormattedValues = () => {
        if (value && Array.isArray(values))
            return values.map(el => getOptionLabel(el)).join(', ');
        if (value)
            return getOptionLabel(values);
        return '-';
    };

    const rest = {};
    if (groupBy)
        rest.groupBy = (option) => {
            return option.groupedBy;
        };

    return (
        <div className={`dropdown-container${viewMode ? ' view-mode' : ''} ${className}`}>
            {
                !viewMode &&
                <Autocomplete className={theme + (dropdownType === 'multiple' ? ' multiple' : '')}
                              multiple={dropdownType === 'multiple'}
                              disabled={disabled}
                              fullWidth
                              getOptionLabel={(option) => getOptionLabel(option)}
                              options={optionList}
                              getOptionDisabled={(option) => firmName != null && (option.NAME === firmName || option.NAME === "  – " + firmName)}
                              value={values}
                              renderInput={(params) =>
                                  <TextField {...params}
                                             label={label}
                                             placeholder={placeholder}
                                             variant="outlined"
                                  />}
                              renderTags={(tagValue, getTagProps) =>
                                  tagValue.map((option, index) =>
                                      <Chip key={index}
                                            {...getTagProps({index})}
                                            deleteIcon={<div className='chip-remove-icon' dangerouslySetInnerHTML={{__html: removeCircle}}/>}
                                            label={getOptionLabel(option)}/>
                                  )}
                              onChange={(event, reason) => handleChangeDropdown({reason, valueKey, dropdownType, optionKey, parentData: data, isFilter})}
                              popupIcon={<div className='dropdown-icon arrow' dangerouslySetInnerHTML={{__html: arrow}}/>}
                              closeIcon={<div className='dropdown-icon' dangerouslySetInnerHTML={{__html: close}}/>}
                              filterOptions={(options, state) => filterOptions(options, state)}
                              {...rest}
                />
            }
            {
                viewMode &&
                <div className={`view-mode-container ${viewClassName}`}>
                    {
                        !['status', 'status-financing'].includes(optionsType) &&
                        <label className='view-mode-label'>{label}</label>
                    }
                    <div className={deleted ? "view-mode-deleted" : ""}>
                        {
                            ['status', 'status-financing'].includes(optionsType) && !label &&
                            <span className='view-mode-label status'>Status</span>
                        }
                        {getFormattedValues()}
                    </div>
                </div>
            }
            {
                hasAgentPercent &&
                <div className='agent-percent-container'>
                    <Input type='text'
                           valueType='agent-percent'
                           name={`${valueKey}_PERCENT`}
                           value={data[`${valueKey}_PERCENT`] || ''}
                           viewMode={viewMode}
                           deleted={deleted}
                           disabled={disabled}
                           handleParentChange={handleChange}
                    />
                </div>
            }
        </div>
    )
};

Dropdown.propTypes = {
    dropdownType: PropTypes.oneOf(['single', 'multiple']),
    options: PropTypes.arrayOf(PropTypes.object),
    optionsType: PropTypes.oneOf(['status', 'source', 'states', 'type', 'transaction', 'category', 'lease', 'market', 'subcategorySTNL', 'subcategoryMT', 'subcategoryIndustrialSTNLMT', 'propertySubcategory', 'superUsers', 'profiles', 'buyerStatus', 'agent', 'buyer', 'firm', 'seller', 'team', 'tenant', 'lender', 'checkbox', 'status-financing', 'loan', 'agent-all', 'borrower']).isRequired,
    optionKey: PropTypes.string,
    optionLabelKey: PropTypes.string,
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    firmName:PropTypes.string,
    label: PropTypes.string,
    data: PropTypes.object,
    hasAgentPercent: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    handleInputParentChange: PropTypes.func,
    disabled: PropTypes.bool,
    viewMode: PropTypes.bool,
    addNewItem: PropTypes.func,
    withAddNew: PropTypes.bool,
    isFilter: PropTypes.bool,
    groupBy: PropTypes.bool,
    theme: PropTypes.oneOf(['default', 'white', 'dark', 'tracking']),
    placeholder: PropTypes.string,
    hasDrawer: PropTypes.bool,
    deleted: PropTypes.bool,
    typeKey: PropTypes.string,
    typeValue: PropTypes.string,
    getSelectedOption: PropTypes.func,
    className: PropTypes.string,
    viewClassName: PropTypes.string,
    index: PropTypes.number,
};

export default Dropdown;
